import React, { useState } from 'react';
import { Link } from 'react-router-dom';
export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
    }
  };
  return <div className="min-h-screen flex items-center justify-center bg-neutral-50" data-id="element-1114">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md" data-id="element-1115">
        <h1 className="text-2xl font-bold mb-6 text-center" data-id="element-1116">Reset Password</h1>
        {submitted ? <div className="text-center" data-id="element-1117">
            <p className="mb-4" data-id="element-1118">
              If an account exists with the email {email}, you will receive
              password reset instructions.
            </p>
            <Link to="/login" className="text-blue-600 hover:text-blue-800" data-id="element-1119">
              Return to login
            </Link>
          </div> : <form onSubmit={handleSubmit} data-id="element-1120">
            <div className="mb-6" data-id="element-1121">
              <label className="block text-sm font-medium mb-1" htmlFor="email" data-id="element-1122">
                Email
              </label>
              <input id="email" type="email" className="w-full p-2 border border-neutral-300 rounded" value={email} onChange={e => setEmail(e.target.value)} required data-id="element-1123" />
            </div>
            <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700" data-id="element-1124">
              Reset Password
            </button>
            <div className="mt-4 text-center" data-id="element-1125">
              <Link to="/login" className="text-blue-600 hover:text-blue-800" data-id="element-1126">
                Back to login
              </Link>
            </div>
          </form>}
      </div>
    </div>;
}